import { config } from '@iheartjane/config';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import noop from 'lodash-es/noop';

import { api } from '@jane/shared/data-access';
import type { Cart } from '@jane/shared/types';

type DeleteCartBody = Pick<Cart, 'uuid'>;

type DeleteCartReturnType = { message: string };

type UseDeleteCartParams = {
  onError?: () => unknown;
  onSuccess?: () => unknown;
};

const cartUrl = () => `${config.apiPath}/carts`;

const deleteCart = async (body: DeleteCartBody) => {
  return await api.delete<DeleteCartReturnType>(cartUrl(), {
    body: JSON.stringify(body),
  });
};

export const useDeleteCart = ({
  onSuccess = noop,
  onError = noop,
}: UseDeleteCartParams = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: deleteCart,
    onError,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['cart'] });
      onSuccess();
    },
  });
};
